import VueRouter from 'vue-router'
const Home = ()=> import('@/pages/Home')
const About = ()=> import('@/pages/About')
const News = ()=> import('@/pages/News')
const NewsDet = ()=> import('@/pages/News/detail.vue')
const Download = ()=>  import('@/pages/Download')
const Innovation = ()=> import('@/pages/Innovation')
const Product = () => import('@/pages/Product')
const Module = () => import('@/pages/Product/module.vue')
const Dealer = () => import('@/pages/Product/dealer.vue')
const Solution = () => import('@/pages/Solution')
const Case = () => import('@/pages/Case')
const Sustain = () => import('@/pages/Sustain')

export default new VueRouter({
    mode:'history',
    routes:[
        {
            path: '/de',
            component: Home
        },
        {
            path: '/de/about',
            component: About
        },
        {   
            name:'news',
            path: '/de/news/:p?',
            component: News,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path: '/de/newsdet',
            component: NewsDet,
            props({query}){
                return { id:query.id }
            }
        },
        {
            name:'load',
            path: '/de/download',
            component: Download,
            props({query}){
                return { pid:query.pid, cid:query.cid, p:query.p }
            }
        },
        {
            path: '/de/innovation',
            component: Innovation
        },
        {
            path: '/de/product',
            component: Product,
            props({query}){
                return { id:query.id }
            }
        },
        {
            path:'/de/module',
            component: Module,
        },
        {
            path:'/de/dealer',
            component: Dealer,
        },
        {
            path: '/de/solution',
            component: Solution,
            props({query}){
                return{ id:query.id }
            }
        },{
            name:'case',
            path:'/de/case',
            component: Case,
            props({query}){
                return { p:query.p }
            }
        },
        {
            path:'/de/sustainability',
            component: Sustain
        }
    ]
})